import {Component, OnDestroy, OnInit} from '@angular/core';
import {TopeCanalService} from '../../../_services/tope-canal.service';
import {TopeCanalFrecuenciaService} from '../../../_services/tope-canal-frecuencia.service';
import {ActivatedRoute} from '@angular/router';
import {NavService} from '../../../_services/_nav.service';
import {Location} from '@angular/common';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CanalService} from '../../../_services/canal.service';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {TopeCanal} from '../../../_models/tope-canal';
import {TopeCanalFrecuencia} from '../../../_models/tope-canal-frecuencia';
import {forkJoin, of, Subject, takeUntil} from 'rxjs';
import {ListaService} from '../../../_services/lista.service';
import {switchMap} from 'rxjs/operators';
import {Canal} from '../../../_models/canal';
import {NgxCurrencyConfig} from 'ngx-currency/lib/ngx-currency.config';
import {AppSettingService} from '../../../_services/app-setting.service';
import {CustomValidators} from '../../../_helpers/formularios-reactivos/custom.validators';

@Component({
  selector: 'app-tope-inversion-editar',
  templateUrl: './tope-inversion-editar.component.html',
  styleUrl: './tope-inversion-editar.component.css'
})
export class TopeInversionEditarComponent implements OnInit, OnDestroy {

  // Variables renderizado
  cargando: boolean = true;
  guardandoCanal: boolean = false;
  guardandoFrecuencia: boolean = false;

  // Formularios
  formularioCanal: FormGroup = new FormGroup({});
  submittedCanal: boolean = false;

  formularioFrecuencia: FormGroup = new FormGroup({});
  submittedFrecuencia: boolean = false;

  // Variables para listas
  listaCanales: SelectItem[] = [];
  listadoFrecuencias: TopeCanalFrecuencia[] = [];
  columns: any[];
  lisFrecuenciasProductos: SelectItem[] = [];
  lisFrecuenciasProductosOriginal: SelectItem[] = [];
  loading: boolean = true;

  // Variables para validaciones
  idTopeCanal: string;
  tabSeleccionado = 'CAN';

  registro: TopeCanal = null;
  frecuencia: TopeCanalFrecuencia = null;

  rangoMininoValido = true;

  // Variables para servicios
  private destroy$ = new Subject<void>();

  constructor(private topeCanalService: TopeCanalService,
              private topeCanalFrecuenciaService: TopeCanalFrecuenciaService,
              private route: ActivatedRoute,
              private canalService: CanalService,
              private fb: FormBuilder,
              private lisServicio: ListaService,
              private conServicio: ConfirmationService,
              private navServicio: NavService,
              private location: Location,
              private appSettingService: AppSettingService) {
  }

  ngOnInit() {
    this.cargarColumnas();
    this.cargaIncial();
  }

  cargarColumnas() {
    this.columns = [
      {field: 'frecuenciaPago', header: this.navServicio.buscarMensaje('TOPESINVERSION.LBL_FRECUENCIAPAGO'), sort: false},
      {field: 'valorMaximo', header: this.navServicio.buscarMensaje('TOPESINVERSION.LBL_VALORMAXIMO'), sort: false},
      {field: 'descripcion', header: this.navServicio.buscarMensaje('TOPESINVERSION.LBL_DESCRIPCION'), sort: false},
      {field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje('LBL_HABILITADO'), sort: false},
      {field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false}
    ];
  }

  cargaIncial() {
    this.idTopeCanal = this.route.snapshot.params['id'];

    forkJoin({
      canales: this.canalService.listadoCanalesHabilitados(),
      topeCanal: this.obtenerTopeCanal(this.idTopeCanal),
      listaFrecuencias: this.lisServicio.getMasterDetails('ListasFrecuenciasProductos'),
      frecuencias: this.obtenerFrecuencias(this.idTopeCanal),
      listadoTopes: this.topeCanalService.listado()
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({canales, topeCanal, listaFrecuencias, frecuencias, listadoTopes}) => {

          const canalesUsados = listadoTopes && listadoTopes.length ? listadoTopes.map(item => item.idCanal) : [];
          let canalesDisponibles = canales?.filter(c => !canalesUsados.includes(c.idCanal)) || [];

          if (topeCanal && topeCanal.idCanal) {
            const opcionActual = canales?.find(c => c.idCanal == topeCanal.idCanal);

            if (opcionActual) {
              canalesDisponibles = [opcionActual,
                ...canalesDisponibles.filter(c => c.idCanal != opcionActual.idCanal)
              ];
            }
          }

          if (canalesDisponibles && canalesDisponibles.length > 0) {
            canalesDisponibles.map(item => {
              this.listaCanales.push({label: item.nombre, value: item.idCanal});
            });
          }

          if (listaFrecuencias && listaFrecuencias.length > 0) {
            listaFrecuencias.map(item => {
              this.lisFrecuenciasProductos.push({label: item.nombre, value: item.idLista});
            });

            this.lisFrecuenciasProductosOriginal = [...this.lisFrecuenciasProductos];
          }

          // Obtener informacion tope de inversion;
          this.registro = topeCanal;
          this.listadoFrecuencias = frecuencias;

          this.filtrarFrecuenciasDisponibles();
          this.construirFormularioCanal();
          this.construirFormularioFrecuencia();
          this.cargando = false;
          this.loading = false;
        },
        error: () => {
          this.registro = null;
          this.listadoFrecuencias = [];
          this.cargando = false;
          this.loading = false;
        }
      });
  }

  filtrarFrecuenciasDisponibles(idFrecuencia?: string) {
    const idsUsados = this.listadoFrecuencias.map(f => f.idFrecuenciasProductos);

    let disponibles = this.lisFrecuenciasProductosOriginal.filter(
      item => !idsUsados.includes(item.value)
    );

    if (idFrecuencia) {
      const opcionActual = this.lisFrecuenciasProductosOriginal.find(item => item.value == idFrecuencia);

      if (opcionActual) {
        disponibles = [opcionActual, ...disponibles];
      }
    }

    this.lisFrecuenciasProductos = disponibles;
  }

  obtenerTopeCanal(id: string) {
    if (!id) {
      return of(null);
    }
    return this.topeCanalService.obtenerPorId(id);
  }

  obtenerFrecuencias(id: string) {
    if (!id) {
      return of([]);
    }
    return this.topeCanalFrecuenciaService.obtenerPorIdTopeCanal(id);
  }

  construirFormularioCanal() {
    this.formularioCanal = this.fb.group({
      idTopeCanal: [this.registro ? this.registro.idTopeCanal : this.idTopeCanal ? this.idTopeCanal : null],
      idCanal: [this.registro ? this.registro.idCanal : null, [Validators.required]],
      montoMinimo: [this.registro ? this.registro.montoMinimo : null, [Validators.required]],
      montoMaximo: [this.registro ? this.registro.montoMaximo : null, [Validators.required]],
      plazoMinimo: [this.registro ? this.registro.plazoMinimo : null, [Validators.required]],
      plazoMaximo: [this.registro ? this.registro.plazoMaximo : null, [Validators.required]],
      indicadorHabilitado: [this.registro ? !!this.registro.indicadorHabilitado : true]
    }, {
      validators: [
        CustomValidators.rangeSequence({ startControlName: 'montoMinimo', endControlName: 'montoMaximo' }),
      ],
    });
  }

  get fc() {
    return this.formularioCanal.controls;
  }

  construirFormularioFrecuencia() {
    this.formularioFrecuencia = this.fb.group({
      idTopeCanalFrecuencia: [this.frecuencia ? this.frecuencia.idTopeCanalFrecuencia : null],
      idTopeCanal: [this.frecuencia ? this.frecuencia.idTopeCanal : this.idTopeCanal ? this.idTopeCanal : null],
      idFrecuenciasProductos: [this.frecuencia ? this.frecuencia.idFrecuenciasProductos : null, [Validators.required]],
      monto: [this.frecuencia ? this.frecuencia.monto : null, [Validators.required]],
      descripcion: [this.frecuencia ? this.frecuencia.descripcion : null, [Validators.required]],
      indicadorHabilitado: [this.frecuencia ? !!this.frecuencia.indicadorHabilitado : true]
    });
  }

  get ff() {
    return this.formularioFrecuencia.controls;
  }

  validarPlazos() {
    let plazoMaximo = this.formularioCanal.get('plazoMaximo').value;
    let plazoMinimo = this.formularioCanal.get('plazoMinimo').value;

    if (!plazoMaximo || !plazoMinimo) {
      this.rangoMininoValido = true;
      return;
    }
    this.rangoMininoValido = Number(plazoMaximo) > Number(plazoMinimo);
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'CAN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'INT';
        break;
      }
      default: {
        break;
      }
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        key: 'topes-canales',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        }
      });
    } else {
      this.location.back();
    }
  }

  agregarTope() {
    this.submittedCanal = true;
    if (this.formularioCanal.invalid || !this.rangoMininoValido) {
      return;
    }
    this.guardandoCanal = true;

    const formulario = this.formularioCanal.getRawValue();

    let i = this.idTopeCanal ? 2 : 1;
    const handler = this.idTopeCanal ? this.topeCanalService.actualizar(formulario)
      : this.topeCanalService.crear(formulario);

    handler.pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.registro = response;
          this.idTopeCanal = response.idTopeCanal;
        },
        error: () => {
          this.registro = null;
          this.navServicio.setMesage(3);
          this.guardandoCanal = false;
          this.submittedCanal = false;
        },
        complete: () => {
          this.navServicio.setMesage(i);
          this.formularioCanal.markAsPristine();
          this.construirFormularioCanal();
          this.submittedCanal = false;
          this.guardandoCanal = false;
          this.tabSeleccionado = 'INT';
        }
      });
  }

  editar(item: TopeCanalFrecuencia) {
    this.frecuencia = item;
    this.filtrarFrecuenciasDisponibles(item.idFrecuenciasProductos);

    // Precargar formulario
    this.construirFormularioFrecuencia();
    this.formularioFrecuencia.updateValueAndValidity();
    this.submittedFrecuencia = false;
  }

  agregarFrecuencia() {
    this.submittedFrecuencia = true;
    if (this.formularioFrecuencia.invalid) {
      return;
    }

    this.loading = true;
    this.guardandoFrecuencia = true;
    const formulario = this.formularioFrecuencia.getRawValue();

    let i = this.idTopeCanal ? 2 : 1;
    const handler = this.frecuencia ? this.topeCanalFrecuenciaService.actualizar(formulario)
      : this.topeCanalFrecuenciaService.crear(formulario);

    handler.pipe(takeUntil(this.destroy$),
      switchMap(() => this.obtenerFrecuencias(this.idTopeCanal)),
    ).subscribe({
      next: (response) => {
        this.listadoFrecuencias = response;
      },
      error: () => {
        this.navServicio.setMesage(3);
        this.submittedFrecuencia = false;
        this.guardandoFrecuencia = false;
        this.loading = false;
      },
      complete: () => {
        this.navServicio.setMesage(i);
        this.resetearValoresFrecuencia();
      }
    });
  }

  cancelarFrecuencia(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        key: 'topes-frecuencias',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.resetearValoresFrecuencia();
        }
      });
    } else {
      this.resetearValoresFrecuencia();
    }
  }

  resetearValoresFrecuencia() {
    this.frecuencia = null;
    this.submittedFrecuencia = false;
    this.guardandoFrecuencia = false;
    this.loading = false;
    this.filtrarFrecuenciasDisponibles();
    this.construirFormularioFrecuencia();
    this.formularioFrecuencia.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get currencyMaskOptions(): Partial<NgxCurrencyConfig> {
    return {
      prefix: '$ ',
      align: 'left',
      thousands: this.appSettingService.separadorMiles,
      allowNegative: false,
      precision : 0,
      nullable: true,
    };
  }
}
